import script from "./CrudProductos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudProductos.vue?vue&type=script&setup=true&lang=js"

import "./CrudProductos.vue?vue&type=style&index=0&id=796d327a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796d327a"]])

export default __exports__